import { Autocomplete, Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { postSA } from '../../../services/apis';
import { useParams } from 'react-router-dom';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';

export const FormCrearSA = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor, opclientes, cargarTareas, opTrabajadores }) => {
    const handleClose = () => {
        setOpen(false);
    };

    const param = useParams();
    const [errorAlert, setErrorAlert] = useState(false);
    const [archivos, setArchivos] = useState([]);
    const [enviando, setEnviando] = useState(false);

    // const [trabajadorSelec, setTrabajadorSelec] = useState({ label: "Aginar a un Trabajador", value: "0" });

    // Estados locales para los campos del formulario
    const [tarea, setTarea] = useState({
        'fecha': new Date(),
        'asunto': null,
        'descripcion': null,
        'localizacion': null,
        'mail': localStorage.getItem('mail'),
        'minutos': null,
        'id_proyecto': param.id
    });

    const handleChange = (event) => {
        const tareaNueva = { ...tarea, [event.target.name]: event.target.value };
        setTarea(tareaNueva);
        setErrorAlert(false);
    };


    const handleArchivoChange = (event) => {
        setArchivos((prevArchivos) => [
            ...prevArchivos,
            ...Array.from(event.target.files) // Agregar los nuevos archivos
        ]);
    };

    const isNullInObject = (obj) => {
        const camposExcepcion = ['localizacion', 'minutos', 'id_cliente', 'id_proyecto'];
        return Object.keys(obj).every(key => {
            if (camposExcepcion.includes(key)) {
                return true;
            }
            return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
        });
    };

    const handleSubmit = (e) => {
        setEnviando(true);
        e.preventDefault();
        const tareaComprobada = isNullInObject(tarea);

        if (!tareaComprobada) {
            console.error("Hay campos vacíos o no válidos en la tarea");
            setErrorAlert(true);
            return; // Detener la ejecución si hay campos no válidos
        }

        crearTarea();
    };

    const crearTarea = async () => {
        const nuevaTareaTmp = { ...tarea };
        // nuevaTareaTmp.trabajadores = trabajadorSelec;

        try {
            const response = await postSA(nuevaTareaTmp, archivos);
            if (response.success === true) {
                cargarTareas();
                setTarea({
                    'fecha': new Date(),
                    'asunto': null,
                    'descripcion': null,
                    'localizacion': null,
                    'mail': localStorage.getItem('mail'),
                    'minutos': null,
                    'id_proyecto': param.id
                });
                // setTrabajadorSelec({ label: "Aginar a un Trabajador", value: "0" });
                handleClose();
                setArchivos([]);
                setEnviando(false);
            }
        } catch (error) {
            console.error("Error cargar tareas", error);
        }
    };
    const eliminarArchivo = (index) => {
        const nuevosArchivos = archivos.filter((_, i) => i !== index);
        setArchivos(nuevosArchivos);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            maxWidth={'sm'}
            fullWidth={true}
        >
            <Backdrop
                sx={{ zIndex: 1000 }}
                open={enviando}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <DialogContent
                style={{
                    backgroundColor: "#" + backgroundCard,
                    color: textColor
                }}
            >

                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    gap={1}
                    sx={{ mb: 3 }}
                >
                    <Typography variant="h6">
                        Nueva Solicitud de Ayuda
                    </Typography>

                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </Grid>

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} direction="column">
                        <Grid item>
                            <TextField
                                disabled
                                label="Mail de respuesta"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="mail"
                                value={tarea.mail}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Asunto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="asunto"
                                value={tarea.asunto}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Descripción"
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                name="descripcion"
                                value={tarea.descripcion}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <Button variant="contained" component="label" sx={{ mt: 2 }}>
                                Subir Archivos
                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    onChange={handleArchivoChange}
                                />
                            </Button>

                            {archivos && archivos.length > 0 && (
                                <div style={{ marginTop: '10px' }}>
                                    {archivos.map((archivo, index) => (
                                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                            <Button
                                                onClick={() => eliminarArchivo(index)}
                                                style={{ marginLeft: '10px', cursor: 'pointer' }}
                                            >
                                                X
                                            </Button>
                                            <span>{archivo.name}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Enviar SA
                </Button>
            </DialogActions>
            {errorAlert && (
                <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta rellenar algún campo obligatorio"} />
            )}
        </Dialog>
    );
};
